import React from 'react';
import cx from 'classnames';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { Button } from '@m4b-design/components';
import { ErrorPage } from '@features/components/error-page';

interface ErrorProps {
  className?: string;
  onRetry?: () => void;
}

export const Error = ({ className, onRetry }: ErrorProps) => {
  const { t } = useTranslation();
  return (
    <ErrorPage
      className={cx('mx-auto', className)}
      hasNewVersion={true}
      title={t('academy_load_fail_page_title')}
      text={t('app_academy_load_fail_page_text')}
      button={
        <Button
          className="!bg-brand01-normal mt-12"
          type="primary"
          onClick={onRetry}>
          {t('app_academy_load_fail_page_btn')}
        </Button>
      }
    />
  );
};
